export const GET_BLOGS_BEGIN = "GET_BLOGS_BEGIN";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_ERROR = "GET_BLOGS_ERROR";

export const GET_BLOGS_SINGLE_BEGIN = "GET_BLOGS_SINGLE_BEGIN";
export const GET_BLOGS_SINGLE_SUCCESS = "GET_BLOGS_SINGLE_SUCCESS";
export const GET_BLOGS_SINGLE_ERROR = "GET_BLOGS_SINGLE_ERROR";